// How often the console asks whether a background sweep has finished.
const POLL_INTERVAL_MS = 5 * 1000;
// A few missed status reads in a row end the watch; the sweep itself carries on.
const MAX_POLL_FAILURES = 3;

let pollTimer = null;
let pollFailures = 0;

// The events and workspaces lists read a catalogue the API rebuilds in the
// background when the console opens. `refreshedAt` moves only when a sweep this
// tab watched has finished, so a list page can watch it and reload.
export const useCatalogStore = defineStore('catalog', {
  state: () => {
    return {
      isRefreshing: false,
      finishedAt: null,
      refreshedAt: null,
    };
  },

  actions: {
    // POST starts a sweep unless one ran within the window; GET only reads.
    async request(method) {
      clearTimeout(pollTimer);

      const response = await useApi[method]('/catalog/refresh').catch((error) => {
        console.error(error);
      });

      if (!response) {
        pollFailures += 1;

        // A lost answer may hide a sweep that did start, so read the state a few
        // times before giving up. Best effort: the lists still show the last
        // catalogue either way.
        this.isRefreshing = pollFailures < MAX_POLL_FAILURES;
        if (this.isRefreshing) {
          pollTimer = setTimeout(() => this.request('get'), POLL_INTERVAL_MS);
        }
        return;
      }

      pollFailures = 0;

      const wasRefreshing = this.isRefreshing;
      this.isRefreshing = response.isRunning;
      this.finishedAt = response.finishedAt;

      if (response.isRunning) {
        pollTimer = setTimeout(() => this.request('get'), POLL_INTERVAL_MS);
      } else if (wasRefreshing) {
        this.refreshedAt = Date.now();
      }
    },
  },
});
